import React from 'react';
import PropTypes from 'prop-types';
// import Members from 'src/components/general/Members';
import BreadcrumbsList from 'src/components/general/BreadcrumbsList';
import { HelpButton } from 'src/components/livy/HelpButton';
import useStyles from './styles';
export default function BreadcrumbsBar(_ref) {
  let _ref$breadcrumbsArray = _ref.breadcrumbsArray,
    breadcrumbsArray = _ref$breadcrumbsArray === void 0 ? [] : _ref$breadcrumbsArray,
    helpTopic = _ref.helpTopic;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumbsBar
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, {
    breadcrumbsArray: breadcrumbsArray
  }), helpTopic && /*#__PURE__*/React.createElement(HelpButton, {
    topic: helpTopic,
    label: "Help for this page"
  }));
}
BreadcrumbsBar.propTypes = {
  breadcrumbsArray: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  })),
  helpTopic: PropTypes.string,
  showMembers: PropTypes.bool
};